export default __webpack_public_path__ + "static/media/resume.7d65e775.pdf";